<template>
  <v-btn
    top
    :right="$vuetify.breakpoint.mdAndUp"
    color="pink"
    class="mb-3 add_btn"
    :block="$vuetify.breakpoint.xs"
    :class="{'mobile':$vuetify.breakpoint.smAndUp}"
    tile
    :disabled="disabled"
    :dark="!disabled"
    @click.stop="click"
  >
    <v-icon>add</v-icon>
    {{text}}
  </v-btn>
</template>
<script>
export default {
  name: "addBtn",
  methods: {
    click() {
      this.$emit("click");
    }
  },
  props: {
    disabled: Boolean,
    text: {
      default: "add"
    }
  }
};
</script>

<style lang="scss" scoped>
.add_btn {
  top: 7px;
}
.add_btn.mobile {
  left: -5px;
}
</style>

